import './ReferralsUsers.sass';

import React, { FC, useEffect, useState } from 'react';
import { Header, Placeholder, ScrollView, Tabs, TabsItem } from '$uikit';
import { Loader, UserCell } from '$shared/components';
import { useDispatch, useSelector } from 'react-redux';
import { inviteActions, inviteSelector } from '$store/invite';
import { useTranslator } from '$hooks';
import {
  ReferralsUsersProps,
  UsersTabsEnum,
} from '$core/ReferralsUsers/ReferralsUsers.interface';
import { showModal } from '$navigation/helper';

export const ReferralsUsers: FC<ReferralsUsersProps> = (props) => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const { invited, subscribed, isStatsLoading, pagination } = useSelector(inviteSelector);

  useEffect(() => {
    if (
      (props.tab === UsersTabsEnum.INVITED && !invited.length) ||
      (props.tab === UsersTabsEnum.SUBSCRIBED && !subscribed.length)
    ) {
      dispatch(inviteActions.loadInviteStats());
    }
  }, []);

  return (
    <>
      <Header showCloseButton>{t('invite_referrals_title')}</Header>
      <ScrollView
        onLoadMore={() => dispatch(inviteActions.loadMore('stats'))}
        canLoadMore={pagination['stats'].nextFrom !== 0}
      >
        <div>
          <Tabs
            selected={props.tab}
            onChange={(value) =>
              showModal(
                value === UsersTabsEnum.SUBSCRIBED
                  ? 'referrals_subscribed'
                  : 'referrals_invited',
              )
            }
          >
            <TabsItem counter={pagination['stats'].length} value={UsersTabsEnum.INVITED}>
              {t('invite_referrals_tab_invited')}
            </TabsItem>
            <TabsItem counter={subscribed.length} value={UsersTabsEnum.SUBSCRIBED}>
              {t('invite_referrals_tab_subscribed')}
            </TabsItem>
          </Tabs>
        </div>
        <div id={props.tab}>
          {!isStatsLoading &&
            ((!subscribed.length && props.tab === UsersTabsEnum.SUBSCRIBED) ||
              (!invited.length && props.tab === UsersTabsEnum.INVITED)) && (
              <Placeholder title={t('invite_referral_empty_title')}>
                {t('invite_referral_empty_description')}
              </Placeholder>
            )}
          {!isStatsLoading ? (
            (props.tab === UsersTabsEnum.SUBSCRIBED ? subscribed : invited).map(
              (userId) => <UserCell key={userId} objectId={userId} skipButton />,
            )
          ) : (
            <Loader isWrapped />
          )}
        </div>
        {pagination['stats'].isLoading && <Loader mode="additional" />}
      </ScrollView>
    </>
  );
};
